<template>
  <div>
    <v-data-table
      :page="table.page"
      :headers="headers"
      :items="table.items"
      :items-per-page="-1"
      :loading="loading.table"
      :server-items-length="table.totalCount"
      hide-default-footer
      :no-data-text="$t('defaults.table.no-data-text')"
      :loading-text="$t('defaults.table.loading-text')"
      :options.sync="table.options"
      class="d-table"
      @update:options="optionsUpdated"
    >
      <template v-slot:[`item.generatedToken`]="{ item }">
        <p class="mb-0" :title="item.generatedToken">
          {{ `${item.generatedToken.substring(0, 50)}...` }}
        </p>
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        {{ formatDate(item.createdAt) }}
      </template>
      <template v-slot:[`item.expiredAt`]="{ item }">
        {{
          item.expiredAt
            ? formatDate(item.expiredAt)
            : $t("tokens.list.table.text.never")
        }}
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <div class="d-flex align-center justify-end">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                color="gray darken-2"
                icon
                @click="copyToken(item.generatedToken)"
              >
                <v-icon size="24"> mdi-content-copy </v-icon>
              </v-btn>
            </template>
            <span>{{
              copied ? $t("defaults.button.copied") : $t("defaults.button.copy")
            }}</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                color="gray darken-2"
                icon
                @click="$emit('edit', item)"
              >
                <v-icon size="24"> mdi-pencil </v-icon>
              </v-btn>
            </template>
            <span>{{ $t("defaults.button.edit") }}</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import tableMixins from "@/mixins/tableMixins";
import { getTokens } from "@/services/token";

export default {
  mixins: [tableMixins],
  data() {
    return {
      headers: [
        {
          text: this.$t("tokens.list.table.headers.token"),
          value: "generatedToken",
          sortable: false,
          width: "30%",
        },
        {
          text: this.$t("tokens.list.table.headers.created"),
          value: "createdAt",
          sortable: false,
        },
        {
          text: this.$t("tokens.list.table.headers.expired"),
          value: "expiredAt",
          sortable: false,
        },
        { text: "", value: "actions", sortable: false, align: "end" },
      ],
      copied: false,
    };
  },
  methods: {
    handleFetchItems() {
      this.fetchItems();
    },
    fetchItems() {
      this.loading.table = true;
      getTokens()
        .then((response) => {
          this.table.items = response;
          this.table.totalCount = response.length;
        })
        .catch(() => {
          this.table.items = [];
          this.table.totalCount = 0;
        })
        .finally(() => {
          this.loading.table = false;
        });
    },
    copyToken(token) {
      const textarea = document.createElement("textarea");
      textarea.value = token;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      this.copied = true;

      setTimeout(() => {
        this.copied = false;
      }, 1000);
    },
  },
  mounted() {
    this.$eventBus.$on("fetchTokens", this.handleFetchItems);
  },
  beforeDestroy() {
    this.$eventBus.$off("fetchTokens", this.handleFetchItems);
  },
};
</script>